<template>
	<div class="MainLayout">
		<el-card class="main-el-card">
			<div slot="header" class="clearfix" v-if="nosearh">
				<slot name="searh"></slot>
			</div>
				<slot name="buttons"></slot>
				<br v-if="nobuttons" /><br v-if="nobuttons" />
				<slot name="table"></slot>
				<br />
				<slot name="Pagination"></slot>
		</el-card>
	</div>
</template>
<script>
	export default{
		name:'MainLayout',
		props:{
			nosearh:{
		      type: Boolean,
		      default: true
		    },
			nobuttons:{
		      type: Boolean,
		      default: true
		    }
		}
	}
</script>
<style>
.MainLayout{padding: 15px;}
</style>
